import React, { useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Container,
  Button,
  Divider,
  TextField,
} from "@mhome/ui";
import { PAMPAS_CAT } from "../config";
import { useAppInterface } from "../app/app-interface-provider";

const DesktopAuthWait = () => {
  const appInterface = useAppInterface();
  const [authId, setAuthId] = useState("");
  const [verifyCode, setVerifyCode] = useState("");

  const handleResendAuthRequest = () => {
    const url = `${PAMPAS_CAT}?source=desktop`;
    appInterface.openAuthUrl(url);
  };

  const handleDevVerify = () => {
    if (appInterface.isAvailable()) {
      appInterface.devVerifyAuth({
        authId,
        verifyCode,
      });
    }
  };

  return (
    <Container maxWidth="sm">
      <div className="flex min-h-screen flex-col items-center justify-center p-6 text-center">
        <Card className="w-full max-w-[500px] rounded-2xl border bg-card shadow-sm">
          <CardContent className="flex flex-col items-center p-8">
            <Typography
              variant="h4"
              component="h1"
              className="mb-4 text-foreground"
            >
              Waiting for Authentication
            </Typography>

            <Typography variant="body1" className="mb-8 text-muted-foreground">
              Please complete the authentication process in your browser.
            </Typography>

            <div className="relative mb-8 inline-flex">
              <div className="h-20 w-20 animate-spin rounded-full border-4 border-primary border-t-transparent" />
            </div>

            <Button
              variant="default"
              onClick={handleResendAuthRequest}
              className="rounded-full"
            >
              Send Auth Request Again
            </Button>

            {process.env.NODE_ENV !== "production" && (
              <>
                <Divider className="my-6 w-full" />

                <Typography
                  variant="h6"
                  component="h2"
                  className="mb-4 text-foreground"
                >
                  Development Mode
                </Typography>

                <div className="flex w-full flex-col gap-4">
                  <TextField
                    label="Auth ID"
                    fullWidth
                    size="medium"
                    placeholder="Enter your authentication ID"
                    value={authId}
                    onChange={(e) => setAuthId(e.target.value)}
                    InputProps={{
                      style: {
                        height: "56px",
                      },
                    }}
                    style={{
                      height: "56px",
                    }}
                  />

                  <TextField
                    label="Verify Code"
                    fullWidth
                    size="medium"
                    placeholder="Enter your verification code"
                    value={verifyCode}
                    onChange={(e) => setVerifyCode(e.target.value)}
                    InputProps={{
                      style: {
                        height: "56px",
                      },
                    }}
                    style={{
                      height: "56px",
                    }}
                  />

                  <Button
                    variant="default"
                    onClick={handleDevVerify}
                    disabled={!authId || !verifyCode}
                    className="rounded-full"
                  >
                    Verify
                  </Button>
                </div>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </Container>
  );
};

export default DesktopAuthWait;
